import { BodyShapeMaleOptionsType } from './types';

export const BODY_SHAPE_MALE_OPTIONS: BodyShapeMaleOptionsType = [
  {
    id: 'slim',
    title: 'Slim',
  },
  {
    id: 'tone',
    title: 'Tone',
  },
  {
    id: 'muscular',
    title: 'Muscular',
  },
  {
    id: 'plus_size',
    title: 'Plus Size',
  },
];
